import { IconTrash03 } from "@pentabd/icons";
import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

interface ActionButtonPropTypes {
  isSaving?: boolean;
  isDeleting?: boolean;
  disabled?: boolean;
  isUpdate?: boolean;
  deleteAction?: () => void;
  closeAction?: () => void;
}

export const ActionButtons = ({
  isSaving,
  isDeleting,
  isUpdate,
  disabled,
  deleteAction,
  closeAction,
}: ActionButtonPropTypes) => {
  const { language } = useLanguage();

  return (
    <div className="col-lg-10 py-10 d-flex justify-content-end gap-8">
      {closeAction && (
        <Button
          htmlType="button"
          fill="outline"
          type="light"
          size="sm"
          onClick={closeAction}
        >
          {language === "en" ? "Close" : "বন্ধ করুন"}
        </Button>
      )}
      <Button
        htmlType="submit"
        loading={isSaving}
        fill="outline"
        type="primary"
        size="sm"
      >
        {isUpdate
          ? language === "en"
            ? "Update"
            : "হালনাগাদ করুন"
          : language === "en"
          ? "Save"
          : "সংরক্ষণ"}
      </Button>
      <Button
        htmlType="button"
        loading={isDeleting}
        type="danger"
        fill="outline"
        size="sm"
        disabled={disabled}
        onClick={deleteAction}
      >
        <IconTrash03 size="20" fill="danger" />
        {language === "en" ? "Delete" : "বাদ দিন"}
      </Button>
    </div>
  );
};
